export default {
    pageTitle: '',
    featurePreviews: [],
    configs: {
        skipCasts: [],
        namingConventions: [],
        automatableModels: [],
        automatableEvents: [],
        automatableCriteriaFields: [],
        automatableExecutionCriteriaFields: {},
        automatableActions: [],
        casts: {},
        dateCasts: {},
        leadBanks: [],
        accidentedParts: [],
        leadForms: [],
        serviceProducts: [],
    },
    groups: [],

    errors: [],
    attachmentParameters: {
        maximumAttachmentSize: 18, // In Megabytes
        blacklistedFileTypes: [
            'ade',
            'adp',
            'avi',
            'bat',
            'chm',
            'cmd',
            'com',
            'cpl',
            'exe',
            'flv',
            'hta',
            'ins',
            'isp',
            'jar',
            'jse',
            'lib',
            'lnk',
            'm2v',
            'm4v',
            'm4v',
            'mde',
            'mkv',
            'mov',
            'mp4',
            'mpeg',
            'mpg',
            'msc',
            'msp',
            'mst',
            'ogg',
            'ogv',
            'pif',
            'scr',
            'sct',
            'shb',
            'sys',
            'vb',
            'vbe',
            'vbs',
            'vob',
            'vxd',
            'webm',
            'wmv',
            'wsc',
            'wsf',
            'wsh',
        ],
        whitelistedFileTypes: [
            'doc',
            'docx',
            'xls',
            'xlsx',
            'ppt',
            'pps',
            'wp',
            'txt',
            'rtf',
            'pdf',
            'gif',
            'jpg',
            'png',
            'htm',
            'html',
            'zip',
            'rar',
            'tar',
            'csv',
        ],
    },
    mergedLead: null,
    specificPhoneToCall: null,
    taskEventToBeCompleted: null,
    webOrderBadgeCount: 0,
    smsBadgeCount: 0,
};
